exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".audio-marker[data-v-d3d79474]{position:absolute;left:0;top:3.75px;z-index:2;margin-left:-6.5px;margin-right:-6.5px}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/AnswerFileFullScreen/src/ViewAudio.vue"],"names":[],"mappings":"AACA,+BAA+B,kBAAkB,OAAO,WAAW,UAAU,mBAAmB,mBAAmB,CAClH","file":"ViewAudio.vue","sourcesContent":["\n.audio-marker[data-v-d3d79474]{position:absolute;left:0;top:3.75px;z-index:2;margin-left:-6.5px;margin-right:-6.5px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d3d79474","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/question-review/components/AnswerFileFullScreen/src/ViewAudio.vue
// module id = 1850
// module chunks = 5 34 108